import { categoryIds } from '../../../constants/common';

const { ONLINE_STORE } = categoryIds;

const isOnlineStoreTemplate = (template) => {
  const { categories = [] } = template.properties;
  return categories.some((category) => category === ONLINE_STORE);
};

export default isOnlineStoreTemplate;
